<template>
  <transition name="pa-simple-fade" @afterEnter="handleAfterEnter">
    <div class="pa-note-list-view" v-if="isDataLoaded" ref="noteListView">
      <transition name="pa-simple-fade">
        <PAParkNoteListView
        v-if="!shoudDisplayBlank"
        :noteList="noteList"
        />
      </transition>

      <transition name="pa-simple-fade">
        <div class="pa-blank-content" v-if="shoudDisplayBlank" ref="blankContent">
          <div class="pa-icon">
            <BlankNoteIcon />
          </div>
          <p class="pa-text">{{blankText}}</p>
          <p class="pa-caption-text">{{blankCaption}}</p>
        </div>
      </transition>

      <ParkNoteListFetchButton
      v-if="noteList.length !== 0"
      :isLoading="isLoadingFetchButton"
      @handleClick="handleClickFetchButton"
      />
    </div>
  </transition>
</template>

<script>
import PAParkNoteListView from '@/components/Parts/PAParkNoteListView/PAParkNoteListView.vue'
import ParkNoteListFetchButton from '@/components/Parts/PAParkNoteListView/ParkNoteListFetchButton.vue'

import BlankNoteIcon from '@/components/Pages/Parks/Detail/PAParkNoteListViewSet/Images/blank-note.svg?inlineN'

import {GetParkNote, GetParkNoteList} from '@/graphql/queries/ParkNote.graphql'

import {GetParkData} from '@/graphql/queries/Park.graphql'

export default {
  props : {
    parkId : {
      default: null
    }
  },

  components : {
    BlankNoteIcon,

    PAParkNoteListView,
    ParkNoteListFetchButton
  },

  data(){
    return {
      isDataLoaded          : false,
      isParkClipped         : false,
      isLoadingFetchButton  : false,

      noteList : [],

      paginateParameters : {
        behaviour : 'refresh',
        list      : [],
        page      : null,
        lastPage  : null,
        total     : null,
        loaded    : false,
      },

      blankText     : '',
      blankCaption  : '',

      blankContent  : {
        blank : {
          text    : '掲示物はありません。',
          caption : '（掲示物の追加は右下のボタンより追加できます。）'
        },
        
        unClip  : {
          text    : '掲示物を表示できません。',
          caption : '（掲示物一覧はクリップ後に表示されます。）'
        }
      }
    };
  },

  computed : {
    shoudDisplayBlank(){
      if(this.noteList.length === 0 && this.isDataLoaded === true){
        return true;
      }else{
        return false;
      }
    }
  },

  apollo : {
    park : {
      query : GetParkData,

      variables(){
        return {
          id : this.parkId
        };
      },

      skip(){
        if(this.parkId === null){
          return true;
        }else{
          return false;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    parkNotes : {
      query : GetParkNoteList,
      
      variables(){
        return {
          park_id   : this.parkId,
          page      : this.paginateParameters.page,
          first     : 10,
          orderBy   : [
            {
              // field : 'created_at',
              column : 'created_at',
              order : 'DESC'
            }
          ]
        };
      },

      result(result){
        const apolloClient = this.$apollo.provider.defaultClient;

        for(let parkNote of result.data.parkNotes.data){
          apolloClient.writeQuery({
            query     : GetParkNote,
            variables : {
              id  : parkNote.id
            },
            data      : {
              parkNote : parkNote
            }
          });
        }

        this.paginateParameters.loaded = true;

        this.$nextTick(() => {
          this.isDataLoaded = true;
        });
      },

      skip(){
        return (this.paginateParameters.page === null);
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },

      fetchPolicy: 'no-cache'
    }
  },

  watch : {
    // isDataLoaded  : {
    //   handler(value){
    //     if(value === true){
    //       console.log('loaded');
    //       this.$nextTick(() => {
    //         this.initializeBlankHeight();
    //       });
    //     }
    //   }
    // },

    isParkClipped : {
      handler(value){
        if(value === true){
          this.noteList = [];
          this.paginateParameters.page = 1;

          this.blankText    = this.blankContent.blank.text;
          this.blankCaption = this.blankContent.blank.caption;
        }else{
          this.paginateParameters.page = null;
          this.noteList = [];

          this.blankText    = this.blankContent.unClip.text;
          this.blankCaption = this.blankContent.unClip.caption;
        }
      },
      immediate: true
    },

    park : {
      handler(data){
        if(typeof data === 'undefined') return;

        if(data !== null){
          this.isParkClipped = data.is_clipped;
        }

        if(this.isParkClipped === false){
          this.$nextTick(() => {
            this.isDataLoaded = true;
          });
        }
      }
    },

    parkNotes : {
      handler(data){
        if(typeof data === 'undefined') return;

        const listViewData = {
          list      : [],
          page      : null,
          lastPage  : null,
          total     : null
        };

        for(let parkNote of data.data){
          listViewData.list.push({
            id  : parkNote.id
          });
        }

        if(typeof data.paginatorInfo !== 'undefined'){
          listViewData.page     = data.paginatorInfo.currentPage;
          listViewData.lastPage = data.paginatorInfo.lastPage;
          listViewData.total    = data.paginatorInfo.total;
        }

        this.setPaginateParameters({
          behaviour : 'push',
          
          list      : listViewData.list,
          page      : listViewData.page,
          lastPage  : listViewData.lastPage,
          total     : listViewData.total
        });
      },
      immediate: true
    }
  },

  methods : {
    async handleClickFetchButton(){
      this.isLoadingFetchButton = true;

      await this.UXWaiting(500);

      if(!(this.paginateParameters.page >= this.paginateParameters.lastPage)){
        const nextPage = (this.paginateParameters.page + 1);

        this.setPaginateParameters({
          behaviour : 'push',
          page      : nextPage
        });
      }

      this.isLoadingFetchButton = false;
    },

    setPaginateParameters(payload){
      if(typeof payload.list !== 'undefined'){
        switch(payload.behaviour){
          case 'refresh':
            this.noteList = payload.list;
          break;

          case 'push':
            for(let parkNote of payload.list){
              let couldRegist = true;

              for(let registerdParkNote of this.noteList){
                if(registerdParkNote.id === parkNote.id){
                  couldRegist = false;
                }
              }

              if(couldRegist){
                this.noteList.push(parkNote);
              }
            }
          break;
        }
      }

      if(typeof payload.page !== 'undefined'){
        this.paginateParameters.page = payload.page;
      }

      if(typeof payload.lastPage !== 'undefined'){
        this.paginateParameters.lastPage = payload.lastPage;
      }

      if(typeof payload.total !== 'undefined'){
        this.paginateParameters.total = payload.total;
      }

      if(typeof payload.loaded !== 'undefined'){
        this.paginateParameters.loaded = payload.loaded;
      }
    },

    handleAfterEnter(){
      this.initializeBlankHeight();
    },

    initializeBlankHeight(){
      if(typeof this.$refs.blankContent === 'undefined') return;
      if(typeof this.$refs.noteListView === 'undefined') return;
      
      const vm = this;

      let intervalId = null;
      const maxTry = 20;
      let counter = 0;

      const setBlankHeight = function(){
        counter++;

        try{
          if(
            (typeof vm.$refs.blankContent !== 'undefined') &&
            (typeof vm.$refs.noteListView !== 'undefined')
          ){
            const checkHeight = vm.$refs.blankContent.offsetHeight;

            if(checkHeight !== 0){
              vm.$refs.noteListView.style.minHeight = checkHeight+'px';

              clearInterval(intervalId);
            }
          }
        }catch(e){
          console.log(e);
        }

        if(counter > maxTry){
          clearInterval(intervalId);
        }
      }

      intervalId = setInterval(setBlankHeight, 300);
    }
  },
}
</script>

<style lang="scss">
.pa-note-list-view{
  position: relative;
  min-height:200px;

  .pa-blank-content{
    width:100%;
    position: absolute;
    top:0;
    text-align: center;
    color:#aa875e;
    padding:2rem 0;

    .pa-icon{
      width:25%;
      margin:0 auto .2rem;

      svg{
        path{
          fill:#B5946C !important;
          stroke:#B5946C !important;
        }
      }
    }

    .pa-text{
      font-size:1rem;
    }
    
    .pa-caption-text{
      font-size: .8rem;;
    }
  }
}
</style>